<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-settings-entity-group"
      :title="$t('entity group') | capitalize"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
    >
      <div class="scroll-kanban">
        <ValidationObserver ref="form-settings-homework-status">
          <div>
            <b-row class="border-right">
              <!-- Abrevisions -->
              <b-col md="6">
                <b-form-group :label="$t('Type')">
                  <ValidationProvider
                    #default="{ errors }"
                    name="type"
                    rules="required"
                  >
                    <v-select
                      :disabled="form.id != null"
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="form.type"
                      :options="[
                        { id: 1, label: 'Employee' },
                        { id: 2, label: 'Driver' },
                        { id: 3, label: 'Vehicle' },
                      ]"
                      :reduce="(val) => val.id"
                      label="label"
                      class="w-100"
                    ></v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group :label="$t('Name')">
                  <ValidationProvider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="form.name"
                      type="text"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col sm="10">
                <b-form-group :label="$t('User')">
                  <vue-autosuggest
                    v-model="userSelect.value"
                    :suggestions="optionsToSuggest"
                    :get-suggestion-value="getSuggestionValue"
                    :input-props="{
                      id: 'autosuggest__input',
                      class: 'form-control',
                      placeholder: $t('Select'),
                    }"
                    @input="searchOnInput"
                    @selected="selectHandler"
                  >
                    <template v-slot="{ suggestion }">
                      <div class="d-flex align-items-center">
                        <b-avatar size="sm" rounded variant="light-success" />
                        <div class="detail ml-50">
                          <b-card-text class="mb-0">
                            {{ suggestion.item.value | capitalize }}
                          </b-card-text>
                        </div>
                      </div>
                    </template>
                  </vue-autosuggest>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group label="' '">
                  <b-button
                    variant="outline-success w-100"
                    @click="addItemUser"
                  >
                    <feather-icon icon="PlusIcon" class="text-success" />
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <h4 class="mt-1 mb-1" v-t="'Users'"></h4>
            <b-row>
              <b-col>
                <div class="overflow-auto" style="height: 300px">
                  <div
                    v-for="user in form.users"
                    :key="user.user_id"
                    class="mt-1 border-bottom row justify-content-between overflow-auto"
                  >
                    <div class="ml-2 mr-2">
                      <b-avatar size="sm" rounded variant="light-success" />
                      <span>
                        {{ user.user_name | capitalize }}
                      </span>
                    </div>
                    <feather-icon
                      icon="DeleteIcon"
                      size="20"
                      class="text-danger mr-2 cursor-pointer"
                      @click="deleteItem(user)"
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </ValidationObserver>
      </div>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="$emit('hideModal', false)"
                v-t="'Cancel'"
              >
              </b-button>
              <b-button variant="primary" @click="onSubmit">
                {{ dataModal.id != null ? $t("Update") : $t("Save") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";

/* Service */
import EntityGroupService from "@/views/settings/views/entity-group/service/entity-group.service.js";
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { VueAutosuggest } from "vue-autosuggest";

export default {
  mixins: [modalMixin],
  components: {
    VueAutosuggest,
  },
  props: {
    dataModal: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      form: {
        id: this.dataModal.id,
        type:
          this.dataModal.type == "Employee"
            ? 1
            : this.dataModal.type == "Driver"
            ? 2
            : 3,
        name: this.dataModal.name,
        users: JSON.parse(this.dataModal.json_users),
      },
      userSelect: {
        id: null,
        user_name: null,
      },
      optionsToSuggest: [],
    };
  },
  mounted() {
    this.toggleModal("modal-settings-entity-group");
  },
  async created() {},
  computed: {},
  methods: {
    async getAttendanceDetailByStatus() {
      try {
        const params = {
          attendance_id: this.dataModal.attendance_id,
          homework_status_id: this.dataModal.homework_status_id,
        };

        // const { data } = await AttendanceService.getAttendanceDetailByStatus(
        //   params
        // );
        // this.items = data;
      } catch (error) {
        console.log(error);
      }
    },
    deleteItem(user) {
      console.log(user);
      this.form.users = this.form.users.filter(
        (item) => item.user_id !== user.user_id
      );
    },
    async onSubmit() {
      try {
        this.addPreloader();
        const params = {
          id: this.form.id,
          type: this.form.type,
          name: this.form.name,
          users: JSON.stringify(this.form.users),
        };

        const data = await EntityGroupService.saveEntityGroup(params);
        this.$emit("hideModal", true);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async searchOnInput(text) {
      this.creditor = null;
      if (text === "" || text === undefined) {
        return;
      }
      try {
        const { data } = await EntityGroupService.getSelectUsers({
          text: text,
        });
        this.optionsToSuggest = [{ data: [...data] }];
      } catch (error) {
        console.log(error);
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.value;
    },
    selectHandler(value) {
      this.userSelect.id = value.item.id;
      this.userSelect.value = value.item.value;
    },
    addItemUser() {
      if (this.userSelect.id == null) {
        return;
      }
      if (this.form.users.find((item) => item.user_id == this.userSelect.id)) {
        this.$toast({
          component: ToastificationContent,
          position: "top-center",
          props: {
            title: "Warning",
            icon: "CoffeeIcon",
            variant: "warning",
            text: "User already registered.",
          },
        });
        return;
      }
      this.form.users.push({
        user_id: this.userSelect.id,
        user_name: this.userSelect.value,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>